import useGetMostViewedOrMostRecentYMM from '@/home/RecommendedCarousels/hooks/useGetMostViewedOrMostRecentYMM';
import useGetRecommendedVehicles from '~/hooks/home/useGetRecommendedVehicles';

const emptyObject = {};

export default function useGetBecauseYouViewed() {
  const targetVehicle = useGetMostViewedOrMostRecentYMM();

  const vehicleId = targetVehicle?.vehicleId;

  const { vehicles, isLoaded } = useGetRecommendedVehicles(
    12,
    emptyObject,
    vehicleId
  );

  return { vehicles, isLoaded };
}
